import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Alert,
  Card,
  CardBody,
  Container,
  FormFeedback,
  Input,
  Label,
  Form,
  Button,
  Spinner,
} from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { cambiarPassword, resetUsuarioFlag } from "../../slices/thunks";

// import images
// import profile from "../../assets/images/bg.png";
import logoLight from "../../assets/images/logo-farme.png";
import ParticlesAuth from "./ParticlesAuth";
import "./Login.css";
import { createSelector } from "reselect";

const ForgetPasswordPage = (props) => {
  const dispatch = useDispatch();

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      usuario: "",
      telefono: "",
    },
    validationSchema: Yup.object({
      usuario: Yup.string().required("Por favor ingrese su usuario"),
      telefono: Yup.string().required(
        "Por favor ingrese su numero de telefono con codigo internacional"
      ),
    }),

    onSubmit: (values) => {
      //console.log(values);

      dispatch(cambiarPassword(values, props.history));
    },
  });

  const selectLayoutState2 = (state) => state;
  const usuarioPageData = createSelector(selectLayoutState2, (state) => ({
    usuario: state.Usuarios.usuario,
    error: state.Usuarios.error,
    loading: state.Usuarios.loading,
    errorMsg: state.Usuarios.errorMsg,
    colorMsg: state.Usuarios.colorMsg,
    exito: state.Usuarios.exito,
  }));

  const { usuario, exito, error, loading, errorMsg, colorMsg } =
    useSelector(usuarioPageData);

  //console.log(usuario, exito, error, loading, errorMsg, colorMsg);

  useEffect(() => {
    
      setTimeout(() => {
        dispatch(resetUsuarioFlag());
      }, 10000);
    
  }, [dispatch, errorMsg]);

  document.title = "Reset Password | Farme";
  return (
    <ParticlesAuth>
      <div className="auth-page-content mt-lg-5">
        <Container>
          <Row>
            <Col lg={12}></Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="mt-4 shadow-lg border-0">
                <CardBody className="p-4">
                  <div className="text-center mt-2 mb-4">
                    <Link to="/" className="d-inline-block auth-logo">
                      <img src={logoLight} alt="" height="50" />
                    </Link>
                  </div>
                  <div className="text-center">
                    <h5 className="text-primary">Resetear Contraseña</h5>
                    <p className="text-muted">Ingresa tu usuario y teléfono para recibir una nueva contraseña</p>
                  </div>

                  {colorMsg && colorMsg ? (
                    <Alert color={colorMsg} className="d-flex align-items-center mt-3">
                      <i className={`ri-${colorMsg === 'success' ? 'checkbox-circle' : 'error-warning'}-line me-2`}></i>
                      <div>{error}</div>
                    </Alert>
                  ) : null}

                  <div className="p-2">
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-4">
                        <Label htmlFor="usuario" className="form-label">
                          Usuario
                        </Label>
                        <div className="form-icon-wrapper">
                          <span className="form-icon-left">
                            <i className="ri-user-line"></i>
                          </span>
                          <Input
                            name="usuario"
                            type="text"
                            className="form-control ps-5"
                            placeholder="Ingrese usuario"
                            autoComplete="username"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.usuario || ""}
                            invalid={
                              validation.touched.usuario &&
                              validation.errors.usuario
                                ? true
                                : false
                            }
                          />
                          {validation.touched.usuario &&
                          validation.errors.usuario ? (
                            <FormFeedback type="invalid">
                              {validation.errors.usuario}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </div>

                      <div className="mb-4">
                        <Label htmlFor="telefono" className="form-label">
                          Teléfono
                        </Label>
                        <div className="form-icon-wrapper">
                          <span className="form-icon-left">
                            <i className="ri-phone-line"></i>
                          </span>
                          <Input
                            name="telefono"
                            type="text"
                            className="form-control ps-5"
                            placeholder="Ingresar teléfono con código internacional"
                            autoComplete="tel"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.telefono || ""}
                            invalid={
                              validation.touched.telefono &&
                              validation.errors.telefono
                                ? true
                                : false
                            }
                          />
                          {validation.touched.telefono &&
                          validation.errors.telefono ? (
                            <FormFeedback type="invalid">
                              {validation.errors.telefono}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </div>

                      <div className="mt-4">
                        <Button
                          color="success"
                          disabled={loading || !(validation.isValid && validation.dirty)}
                          className="btn btn-success w-100"
                          type="submit"
                        >
                          {loading ? (
                            <>
                              <Spinner size="sm" className="me-2">
                                Loading...
                              </Spinner>
                              Enviando...
                            </>
                          ) : (
                            "Enviar nueva contraseña a mi teléfono"
                          )}
                        </Button>
                        {!(validation.isValid && validation.dirty) && !loading && (
                          <div className="text-muted text-center mt-2 fs-12">
                            Por favor, complete todos los campos para continuar
                          </div>
                        )}
                      </div>

                      <div className="mt-4 text-center">
                        <p className="mb-0">
                          Recordaste tu contraseña?{" "}
                          <Link to="/login" className="fw-semibold text-primary">
                            Volver al Login
                          </Link>
                        </p>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </ParticlesAuth>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
